import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { Button, Typography } from "~/common/mui";

type AccordionSummaryToggleProps = {
  open: boolean;
  onClick?: () => void;
  showLabel: string;
  hideLabel: string;
  disabled?: boolean;
};

export const AccordionSummaryToggle = ({
  open,
  onClick,
  showLabel,
  hideLabel,
  disabled,
}: AccordionSummaryToggleProps) => {
  return (
    <Button
      variant="text"
      color="textPrimary"
      startIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      onClick={onClick}
      disabled={disabled}
    >
      <Typography variant="labelLarge" fontWeight="normal">
        {open ? hideLabel : showLabel}
      </Typography>
    </Button>
  );
};
